import React, { useEffect, useState } from "react";
import { Modal, ModalHeader, ModalBody, ModalTitle, ModalFooter, Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import Personal from "./personal";
import Academic from "./academic";

interface AddStudentModalProps {
    show: boolean;
    onHide: () => void;
    isEdit: boolean;
    studentData?: any;
    onSave: (data: any) => void;
    insDet: (data: any[]) => void;
    sprtDet: (data: any[]) => void;
    progDet: (data: any[]) => void;
    billDet: (data: any[]) => void;
    validate: (data: any[]) => void;
}

const AddStudent: React.FC<AddStudentModalProps> = ({ show, onHide, isEdit, studentData, onSave, insDet, sprtDet, progDet, billDet, validate }) => {

    const [activeTab, setActiveTab] = useState("Personal");
    const [personalData, setPersonalData] = useState({});
    const [academicData, setAcademicData] = useState({});

    const handlePersonalDataChange = (data: any) => setPersonalData(data);
    const handleAcademicDataChange = (data: any) => setAcademicData(data);

    const handleSubmit = (e) => {
        e.preventDefault();
        if (!validate.current.checkValidity()) {
            validate.current.reportValidity();
        } else {
            const finalData = { ...personalData, ...academicData };
            // console.log("Submitting Data:", finalData);
            onSave(finalData);
        }
    };

    const handleNext = (e) => {
        e.preventDefault();
        if (!validate.current.checkValidity()) {
            validate.current.reportValidity();
        } else {
            setActiveTab("Academic");
        }
    };

    const handleBack = () => {
        setActiveTab("Personal");
    };

    const tabData = [
        {
            icon: <i className="fas fa-child" />,
            name: "Personal",
            content: <Personal onDataChange={handlePersonalDataChange} studDet={studentData} onNext={handleNext} formcheck={validate} />
        },
        {
            icon: <i className="fas fa-university" />,
            name: "Academic",
            content: <Academic onDataChange={handleAcademicDataChange} onBack={handleBack} isEdit={isEdit} insDet={insDet} sprtDet={sprtDet} progDet={progDet} billDet={billDet} studDet={studentData} formcheck={validate} submit={handleSubmit} />
        },
    ]

    return (
        <>
            <Modal show={show} onHide={onHide} size="xl" centered>
                <ModalHeader>
                    <ModalTitle>
                        <i className="fas fa-plus" />
                        <b>{isEdit ? "Edit Student" : "Add Student"}</b>
                    </ModalTitle>
                </ModalHeader>
                <ModalBody>
                    <div className="row">
                        <div className="row d-flex align-items-center">
                            <div className="col-xl-12 col-lg-12 col-sm-12 col-md-12">
                                <div className="coach-court-list">
                                    <ul className="nav">
                                        {tabData.map((tab, i) => (
                                            <li key={i} style={{ flex: "1", textAlign: "center", width: "100%" }}>
                                                <Link to="#"
                                                    className={tab.name === activeTab ? 'active' : ''}
                                                    style={{ display: "block", width: "100%" }}
                                                    onClick={() => setActiveTab(tab.name)}>
                                                    {tab.icon}  {tab.name}
                                                </Link>
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            </div>
                            <div className="tab-content">
                                {tabData
                                    .filter(tab => tab.name === activeTab)
                                    .map((tab, i) => (
                                        <div key={i}>{tab.content}</div>
                                    ))}
                            </div>
                        </div>
                    </div>
                </ModalBody>
                {/* <ModalFooter>
                    <Button
                        className="btn-primary"
                        variant="success"
                        // onClick={saveStudent}
                        onClick={handleSubmit}
                    >
                        <b>{isEdit ? "Update" : "Save"}</b>
                    </Button>
                </ModalFooter> */}
            </Modal>
        </>
    );
};

export default AddStudent;